'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _support = require('helpers/support');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const mapCode = {
//   style: 'img',
//   color: 'text',
// };
var ServiceOptions = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ServiceOptions, _Component);

  function ServiceOptions(props) {
    (0, _classCallCheck3.default)(this, ServiceOptions);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceOptions.__proto__ || (0, _getPrototypeOf2.default)(ServiceOptions)).call(this, props));

    _this.state = {
      service: null,
      selectedOptions: {}, // lưu những option bình thường được chọn.
      newOptions: [] // lưu option là hình được upload lên, cái này hiện tại chưa làm
    };
    if (props.service && props.service.groupedOptions && props.service.groupedOptions.length) {
      props.service.groupedOptions.map(function (group) {
        if (group._id) {
          _this.state.selectedOptions[group._id] = [];
        }
      });
    }
    _this.toBooking = _this.toBooking.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ServiceOptions, [{
    key: 'onChangeOption',
    value: function onChangeOption(option, groupOption) {
      var newSelectedOptions = (0, _extends3.default)({}, this.state.selectedOptions);
      if (!newSelectedOptions[groupOption._id]) {
        newSelectedOptions[groupOption._id] = [];
      }
      if (option && option._id) {
        var exist = newSelectedOptions[groupOption._id].find(function (op) {
          return op._id === option._id;
        });
        switch (groupOption.type) {
          case 'single':
            if (!exist) {
              newSelectedOptions[groupOption._id] = [option];
            }
            break;
          case 'multiple':
            if (exist) {
              newSelectedOptions[groupOption._id] = _support.Helper.removeOptions(newSelectedOptions[groupOption._id], option);
            } else {
              newSelectedOptions[groupOption._id] = _support.Helper.addOptions(newSelectedOptions[groupOption._id], option);
            }
            break;
          default:
            break;
        }
        this.setState({ selectedOptions: newSelectedOptions });
      }
    }
  }, {
    key: 'renderOptionText',
    value: function renderOptionText(options, groupOption) {
      var _this2 = this;

      var selectedOptions = this.state.selectedOptions;

      if (options && options.length) {
        return options.map(function (option) {
          var opActive = !!(selectedOptions[groupOption._id] && selectedOptions[groupOption._id].find(function (v) {
            return v._id === option._id;
          }));
          return _react2.default.createElement(_components.SelectRadio, {
            onClick: function onClick() {
              return _this2.onChangeOption(option, groupOption);
            },
            active: !!opActive,
            data: { value: option.text, key: option._id }
          });
        });
      }
    }
  }, {
    key: 'renderOptionImage',
    value: function renderOptionImage(options, groupOption) {
      var _this3 = this;

      var selectedOptions = this.state.selectedOptions;

      var styles = require('./ServiceOptions.scss');
      if (options && options.length) {
        return options.map(function (option) {
          var opActive = !!(selectedOptions[groupOption._id] && selectedOptions[groupOption._id].find(function (v) {
            return v._id === option._id;
          }));
          return _react2.default.createElement('img', {
            src: option.image,
            onClick: function onClick() {
              return _this3.onChangeOption(option, groupOption);
            },
            className: styles.image + ' ' + (opActive ? styles.active : ''),
            data: { value: option.text, key: option._id }
          });
        });
      }
    }
  }, {
    key: 'renderGroupOption',
    value: function renderGroupOption() {
      var _this4 = this;

      var styles = require('./ServiceOptions.scss');
      var groupedOptions = this.props.service.groupedOptions;

      return groupedOptions.map(function (groupOption) {
        var name = groupOption.name,
            options = groupOption.options,
            childrenType = groupOption.childrenType;

        switch (childrenType) {
          case 'text':
            return _react2.default.createElement(
              _components.Expand,
              { contentClassName: styles.content, titleLeft: name, show: true },
              _this4.renderOptionText(options, groupOption)
            );
          case 'image':
            return _react2.default.createElement(
              _components.Expand,
              {
                contentClassName: styles.contentImage,
                titleLeft: name,
                show: true
              },
              _this4.renderOptionImage(options, groupOption)
            );
          default:
            break;
        }
      });
    }
  }, {
    key: 'toBooking',
    value: function toBooking() {
      var _props = this.props,
          service = _props.service,
          toBooking = _props.toBooking;
      var _state = this.state,
          selectedOptions = _state.selectedOptions,
          newOptions = _state.newOptions;

      if (toBooking) {
        toBooking({ service: service, selectedOptions: selectedOptions, newOptions: newOptions });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ServiceOptions.scss');

      var _props2 = this.props,
          show = _props2.show,
          onHide = _props2.onHide,
          service = _props2.service;

      return _react2.default.createElement(
        _components.SlideCustom,
        {
          key: 'modal_flow_promotion',
          show: show,
          onHide: onHide,
          contentClassName: styles.optionContent
          // title={service ? service.name : 'Tùy chọn dịch vụ'}
        },
        _react2.default.createElement(
          'div',
          { className: styles.headOption },
          service.name,
          _react2.default.createElement('img', { src: _Images2.default.home.closeBlack, alt: '', onClick: onHide })
        ),
        !!(service && service.groupedOptions) && this.renderGroupOption(),
        _react2.default.createElement(
          'div',
          { className: styles.footerOption },
          _react2.default.createElement(
            'div',
            { className: styles.labelBox },
            _react2.default.createElement(
              'label',
              null,
              'T\u1EA1m t\xEDnh'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.groupPrice },
              _react2.default.createElement(
                'p',
                null,
                service.price
              ),
              _react2.default.createElement(
                'span',
                null,
                '200.000\u0111'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.btnBooking, onClick: this.toBooking },
            '\u0110\u1EB7t L\u1ECBch'
          )
        )
      );
    }
  }]);
  return ServiceOptions;
}(_react.Component), _class.propTypes = {
  show: _react.PropTypes.bool,
  service: _react.PropTypes.object,
  // @action
  onHide: _react.PropTypes.func,
  toBooking: _react.PropTypes.func
}, _temp);
exports.default = ServiceOptions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/HomeService/ServiceOptions.js
// module id = 1580
// module chunks = 0